/**
 * DevExtreme (esm/ui/list_light.js)
 * Version: 23.1.5
 * Build date: Wed Aug 30 2023
 *
 * Copyright (c) 2012 - 2023 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
import ListEdit from "./list/ui.list.edit.search";
import registerComponent from "../core/component_registrator";
registerComponent("dxList", ListEdit);
export default ListEdit;
